// Error Messages
export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Enter a valid email and password.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  RESET_LINK_FAILED: 'Failed to send password reset link.',
  PASSWORD_REQUIRED: 'Password is required',
} as const;

// Success Messages
export const AUTH_SUCCESS = {
  VERIFICATION_CODE_SENT: 'Verification Code Sent.',
  RESET_LINK_SENT: 'Password reset link was sent to your email.',
} as const;

// Auth route paths
export const AUTH_PATHS = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  NEW_PASSWORD_REQUIRED: '/new-password-required',
  MFA_SETUP_PHONE: '/mfa-setup-phone',
  MFA_VERIFICATION: '/mfa-verification',
  HOME: '/',
} as const;

export type AuthPaths = typeof AUTH_PATHS;

export const AUTH_SESSION_KEYS = {
  NEW_PASSWORD_REQUIRED: 'newPasswordRequired',
  POST_LOGIN_REDIRECT: 'postLoginRedirect',
} as const;
